module.exports = __webpack_public_path__ + "img/aiAssistance.69c4560a.png";